import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'babel-polyfill'
import * as React from 'react'
import * as ReactDOM from 'react-dom'

import App from './App'
import './index.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { unregister } from './registerServiceWorker'

ReactDOM.render(<App />, document.getElementById('root'))
unregister()



// WEBPACK FOOTER //
// ./src/index.tsx